import {PlusIcon} from '@primer/octicons-react'
import {Button, IconButton} from '@primer/react'
import {Tooltip} from '@primer/react/deprecated'
import {useState} from 'react'

import {BUTTON_LABELS} from '../../constants/buttons'

const LOADING_TOOLTIP = 'Loading...'

type CreateIssueButtonShellProps = {
  iconOnly?: boolean
}

/**
 * Lightweight shell that mirrors the visual appearance of
 * `@github-ui/issue-create/CreateIssueButton` without pulling in its heavy
 * dependency graph.  Used as the Suspense fallback so users see a real button
 * instead of nothing while the full component lazy-loads.
 *
 * Clicking the shell triggers the lazy chunk and puts the button into a
 * disabled / loading state until React swaps in the real component.
 */
export function CreateIssueButtonShell({iconOnly = false}: CreateIssueButtonShellProps = {}) {
  const [clicked, setClicked] = useState(false)

  if (iconOnly) {
    if (clicked) {
      return (
        <Tooltip aria-label={LOADING_TOOLTIP}>
          <IconButton size="medium" icon={PlusIcon} aria-label={BUTTON_LABELS.new} disabled />
        </Tooltip>
      )
    }
    return <IconButton size="medium" icon={PlusIcon} aria-label={BUTTON_LABELS.new} onClick={() => setClicked(true)} />
  }

  if (clicked) {
    return (
      <Tooltip aria-label={LOADING_TOOLTIP}>
        <Button size={'medium'} disabled>
          {BUTTON_LABELS.new}
        </Button>
      </Tooltip>
    )
  }

  return (
    <Button size={'medium'} variant="primary" onClick={() => setClicked(true)}>
      {BUTTON_LABELS.new}
    </Button>
  )
}
